<template src="./index.html"></template>
<script>
import minhead from '../../../../common/minHead/index.vue';
import SalesTaxReportTree from '../../../../common/SalesTaxReportTree/index.vue';
import SalesTaxReportbox from '../../../../common/SalesTaxReportbox/index.vue';
import { getdata } from './data.js';
import config from '../../../../../../configHttp.js';
import uploadFile from '../../../../common/uploadFile/index.vue';
import uploadFileplus from '../../../../common/uploadFileplus/index.vue';
import {
    querycell,
    writesave,
    startShenBao,
    forShengcdg,
    manuscriptqueryReportStep,
    manuscriptwriteimport,
    manuscriptUploadFile,
    annexadd,
    findConpanyConfig
} from '../../../../../api/Draftgeneration.js';
import { querytemplatecell, getShuibDetailList, templatecellsave } from '../../../../../api/bbmb.js';
import { reportquerytrack } from '../../../../../api/xggj.js';
import { zcfg_fycx, zcfg_fetch } from '../../../../../api/zcfg.js';
import addzc from '../../../../common/addzc/index.vue';
import seezc from '../../../../common/seezc/index.vue';
import GeneralReturn_I from './GeneralReturn_I/index.vue';
import GeneralReturn_II from './GeneralReturn_II/index.vue';
import GeneralReturn_III from './GeneralReturn_III/index.vue';
import { getdata as getdataI } from './GeneralReturn_I/data.js';
export default {
    name: '',
    components: {
        minhead,
        SalesTaxReportTree,
        SalesTaxReportbox,
        uploadFile,
        uploadFileplus,
        addzc,
        seezc,
        GeneralReturn_I,
        GeneralReturn_II,
        GeneralReturn_III
    },
    props: {
        type: {
            type: String,
            default: ''
        },
        params: {
            type: Object,
            default: {}
        },
        sbqj: {
            type: String,
            default: ''
        },
        showbox: {
            type: Boolean,
            default: false
        },
        mintext: {
            type: String,
            default: '填写'
        },
        toseeUpdate: {
            type: Boolean,
            default: false
        },
        seeNow: {
            type: Boolean,
            default: false
        },
        suosq: {
            type: String,
            default: ''
        }
    },
    mounted() {
        if (this.toseeUpdate) {
            this.getShuibDetailList();
        } else {
            this.manuscriptqueryReportStep();
        }
    },
    data: function () {
        return {
            Changed:0,
            start: '',
            stop: '',
            treestate: '',
            statedata: [],
            treedata: getdata().treedata,
            choosetitleindex: '',
            formlist: getdata().formlist,
            headobj: {},
            choosecellCode: '',
            smtext: '',
            zcdata: [],
            option: [
                {
                    value: '30221',
                    label: '水利建设专项收入'
                },
                {
                    value: '39900',
                    label: '其他收入'
                },
                {
                    value: '30299',
                    label: '建设行政事业性收费收入'
                }
            ],
            searchlistzc: getdata().searchlistzc,
            headDatazc: getdata().headDatazc,
            pagination: getdata().pagination,
            seezcformlist: getdata().seezcformlist,
            formdatazc: getdata().formdatazc, //form表单数据
            //表一
            tableDataI_I: [],
            tableDataI_II: [],
            tableDataI_III: [],
            IHead: [
                'ty_0_x_1',
                'ty_0_x_1a',
                'ty_0_x_2',
                'ty_0_x_2a',
                'ty_0_x_3',
                'ty_0_x_3a',
                'ty_0_x_4',
                'ty_0_x_5',
                'ty_0_x_6',
                'ty_0_x_7',
                'ty_0_x_8',
                'ty_0_x_9',
                'ty_0_x_10',
                'ty_0_x_11',
                'ty_0_x_12',
                'ty_0_x_13',
                'ty_0_x_14',
                'ty_0_x_14a',
                'ty_0_x_15',
                'ty_0_x_16',
                'ty_0_x_17',
                'ty_0_x_18',
                'ty_0_x_19'
            ],
            //表三
            choosetable: '',
            chooseindex: '',
            choosecolum: '',
            delCellsI: []
        };
    },

    methods: {
        //政策点击预览
        zcsclick(id) {
            this.$refs.boxref.zcsclick(id);
        },
        //选中格子
        forhover(table, colum, index) {
            this.$refs.boxref.forhover(table, colum, index);
        },
        //获取选中格子
        getchoosecellCode(table, colum, index) {
            if (this.$emptyandnull(table)) {
                this.choosecellCode = '';
                return false;
            }
            this.choosetable = table;
            this.chooseindex = index;
            this.choosecolum = colum;
            this.choosecellCode = this[table][index][colum].cellCode;
            if (this.toseeUpdate) {
                this.smtext = this[table][index][colum]['map'] ? this[table][index][colum]['map']['desc'] : '';
                this.zcdata = this[table][index][colum]['map'] ? this[table][index][colum]['map']['zcs'] : [];
            } else {
                this.smtext = this[table][index][colum]['updateDesc'] || '';
            }
        },
        //更正说明
        forgengzheng(table, colum, index, smtext) {
            this[table][index][colum]['updateDesc'] = smtext;
        },
        //更正政策和说明
        forxzsm(table, colum, index, smtext, zcdata) {
            this[table][index][colum]['map'] = {
                desc: '',
                zcs: []
            };
            this[table][index][colum]['map']['desc'] = smtext;
            this[table][index][colum]['map']['zcs'] = zcdata;
        },
        //点击全部范围
        refreshhover() {
            this.$nextTick(() => {
                this.$refs.boxref.refreshhover();
            });
        },
        getShuibDetailList() {
            getShuibDetailList({
                shuizId: this.params.shuizId,
                id: this.params.shuibId
            }).then((res) => {
                if (res.data.code == 1) {
                    this.treedata = res.data.data;
                    if (this.treedata[0]) {
                        this.getchoosetitleindex(this.treedata[0]);
                    }
                    this.querycell();
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        manuscriptqueryReportStep() {
            manuscriptqueryReportStep({
                id: this.params.id,
                sbbm: this.params.sbbm
            }).then((res) => {
                if (res.data.code == 1) {
                    this.statedata = res.data.data.statusHistory;
                    this.treedata = res.data.data.detail;
                    if (this.treedata[0]) {
                        this.getchoosetitleindex(this.treedata[0]);
                    }
                    this.querycell();
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        getchoosetitleindex(item) {
            this.choosetitleindex = item.shuibNameCode;
        },
        //表格隐藏显示和返回
        forback() {
            if(this.Changed>0){
                    this.$showConfirm({
                        message: "是否不保存当前修改?",
                        title:"您好未保存",
                    }).then((res) => {
                        if (res == "confirm") {
                            this.$emit('forback', true);
                        }else{
                            //取消
                        }
                    });
            }else{
                this.$emit('forback', true);
            }
		},
        changestate(e) {
            this.treestate = e;
        },
        //传给后端值处理
        filternums(data, filterlist) {
            var newlist = [];
            filterlist.forEach((ytem) => {
                let newval = data.map((item) => {
                    if (
                        item[ytem] != undefined &&
                        item[ytem] != 'undefined' &&
                        this.$notemptyandnull(item[ytem]) &&
                        item[ytem].cellVal != '合计'
                    ) {
                        return item[ytem];
                    } else {
                        return 'x';
                    }
                });
                newlist = [...newlist, ...newval].filter((gtem) => gtem != 'x');
            });
            return newlist;
        },

        refreshtableDataI() {
            this.tableDataI_I.forEach((item, index) => {
                this.IHead.forEach((gtem) => {
                    if (item[gtem] && item[gtem].cellVal && item[gtem].cellVal != '' && item[gtem].cellVal != '- -') {
                        item[gtem].cellVal = '';
                        item[gtem].cellType = '';
                    }
                });
            });
        },
        commanddcrefresh(e) {
            this.Changed++
            if (e == 'all') {
                Object.keys(this.headobj).map((key) => (this.headobj[key] = ''));
                this.refreshtableDataI();
            }
        },
        //所有表格渲染
        querycell(index) {

            if (this.type == 'update') {
                querycell({
                    companyNo: this.params.companyNo, // 公司编号
                    id: this.params.id, //报表id
                    shuibId: this.params.shuibId, //税种id
                    sbbm: this.params.sbbm
                }).then((res) => {
                    let dataarr = res.data.data;
                    this.gettable(dataarr);
                });
            }
            if (this.type == 'tosee') {
                if (this.seeNow) {
                    querycell({
                        companyNo: this.params.companyNo, // 公司编号
                        id: this.params.id, //报表id
                        shuibId: this.params.shuibId, //税种id
                        sbbm: this.params.sbbm
                    }).then((res) => {
                        let dataarr = res.data.data;
                        this.gettable(dataarr);
                    });
                    return false;
                }
                if (this.toseeUpdate) {
                    querytemplatecell({
                        shuibId: this.params.shuibId,
                        id: this.params.id
                    }).then((res) => {
                        let dataarr = res.data.data;
                        this.gettable(dataarr);
                    });
                } else {
                    reportquerytrack({
                        companyNo: this.params.companyNo, // 公司编号
                        id: this.params.id, //报表id
                        shuibId: this.params.shuibId, //税种id
                        sbbm: this.params.sbbm,
                        trackId: this.params.trackId
                    }).then((res) => {
                        let dataarr = res.data.data;
                        this.gettable(dataarr);
                    });
                }
            }
        },
        time() {
            let params = {
                companyCode: this.params.companyCode,
                shuiBNameCode: this.params.sbbm
            };
            findConpanyConfig(params).then((res) => {
                if (res.data.code == 1) {
                    let time = new Date();
                    var year = time.getFullYear(); // 获取年
                    var month = time.getMonth() + 1; // 获取月
                    if (res.data.data[0].shenbzq == 1 || res.data.data.shenbzq == 0) {
                        let data = new Date(year, month - 1);
                        let day = new Date(year, month - 1, 0).getDate();
                        this.start = year + '-' + (month - 1 > 9 ? month - 1 : '0' + (month - 1)) + '-' + '01';
                        this.stop = year + '-' + (month - 1 > 9 ? month - 1 : '0' + (month - 1)) + '-' + day;
                    } else if (res.data.data[0].shenbzq == 2) {
                        let num = Math.ceil(month / 3);
                        if (num == 1) {
                            this.start = year - 1 + '-09-' + '01';
                            this.stop = year - 1 + '-' + 12 + '-' + '31';
                        } else {
                            let day = new Date(year, (num - 1) * 3, 0).getDate();
                            this.start = year + '-' + ((num - 1) * 3 - 2 > 9 ? (num - 1) * 3 - 2 : '0' + (num - 1) * 3 - 2) + '-' + '01';
                            this.stop = year + '-' + ((num - 1) * 3 > 9 ? (num - 1) * 3 : '0' + (num - 1) * 3) + '-' + day;
                        }
                    } else if (res.data.data[0].shenbzq == 3) {
                        if (num == 1) {
                            this.start = year - 1 + '-07-' + '01';
                            this.stop = year - 1 + '-12-' + '31';
                        } else if (num == 7) {
                            this.start = year + '-01-' + '01';
                            this.stop = year + '-07-' + '31';
                        }
                    } else if (res.data.data[0].shenbzq == 4) {
                        let day = new Date(year - 1, 12, 0).getDate();
                        this.start = year + '-01-' + '01';
                        this.stop = year + '-' + 12 + '-' + '31';
                    }
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        gettable(dataarr) {
            this.headobj = dataarr.head;
            if (dataarr.ty_0) {
                dataarr.ty_0.map((item, index) => {
                    if (index != dataarr.ty_0.length - 1) {
                        this.selectchange(item, 'ty_');
                        this.selectchangetwo(item, 'ty_');
                        this.selectchangethree(item, 'ty_');
                        this.selectJm(item,'ty_')
                    }
                    if (item.ty_0_x_1) {
                        if (item.ty_0_x_1.cellVal == 0) {
                            item.ty_0_x_1.cellVal = '';
                        }
                    }
                    if (item.ty_0_x_2) {
                        if (item.ty_0_x_2.cellVal == 0) {
                            item.ty_0_x_2.cellVal = '';
                        }
                    }
                    if (item.ty_0_x_3) {
                        if (item.ty_0_x_3.cellVal == 0) {
                            item.ty_0_x_3.cellVal = '';
                        }
                    }
                    if (item.ty_0_x_4) {
                        if (item.ty_0_x_4.cellVal == 0 || item.ty_0_x_4.cellVal == '') {
                            item.ty_0_x_4.cellVal = this.start;
                        }
                    }
                    if (item.ty_0_x_5) {
                        if (item.ty_0_x_5.cellVal == 0 || item.ty_0_x_5.cellVal == '') {
                            item.ty_0_x_5.cellVal = this.stop;
                        }
                    }
                    if (item.ty_0_x_14) {
                        if (item.ty_0_x_14.cellVal == 0) {
                            item.ty_0_x_14.cellVal = '';
                        }
                    }
                });
            }
            this.tableDataI_I = dataarr.ty_0;
            // if(dataarr.tylj_0){
            //                 let key = ['tylj_0_x_4','tylj_0_x_5','tylj_0_x_2','tylj_0_x_3']
            //                 if(dataarr.tylj_0[0].tylj_0_x_1.cellVal==''||dataarr.tylj_0[0].tylj_0_x_1.cellVal=='0'||dataarr.tylj_0[0].tylj_0_x_1.cellVal==null){
            // 		dataarr.tylj_0[0].tylj_0_x_1.cellVal = '30299'
            // 		dataarr.tylj_0[0].tylj_0_x_1a.cellVal = '建设行政事业性收费收入'
            // 	}
            // 	dataarr.tylj_0.map((item,index)=>{
            // 		if(index!=dataarr.tylj_0.length-1){
            // 			this.selectchange(item,'tylj_')
            // 			this.selectchangetwo(item,'tylj_')
            // 			this.selectchangethree(item,'tylj_')
            // 		}
            //                     key.map(item1=>{
            //                         if(item[item1].cellVal==0){
            //                             item[item1]=''
            //                         }
            //                     })
            // 	})
            // 	this.tableDataI_I = dataarr.tylj_0
            // }
            // if(dataarr.tygh_0){
            //                 let key = ['tygh_0_x_4','tygh_0_x_5','tygh_0_x_2','tygh_0_x_3']
            //                 if(dataarr.tygh_0[0].tygh_0_x_1.cellVal==''||dataarr.tygh_0[0].tygh_0_x_1.cellVal=='0'||dataarr.tygh_0[0].tygh_0_x_1.cellVal==null){
            // 		dataarr.tygh_0[0].tygh_0_x_1.cellVal = '39900'
            // 		dataarr.tygh_0[0].tygh_0_x_1a.cellVal = '其他收入'
            // 	}
            // 	dataarr.tygh_0.map((item,index)=>{
            // 		if(index!=dataarr.tygh_0.length-1){
            // 			this.selectchange(item,'tygh_')
            // 			this.selectchangetwo(item,'tygh_')
            // 			this.selectchangethree(item,'tygh_')
            // 		}
            //                     key.map(item1=>{
            //                         if(item[item1].cellVal==0){
            //                             item[item1]=''
            //                         }
            //                     })
            // 	})

            // 	this.tableDataI_II = dataarr.tygh_0
            // }
            // if(dataarr.tysl_0){
            //                 let key = ['tysl_0_x_4','tysl_0_x_5','tysl_0_x_2','tysl_0_x_3']
            // 	if(dataarr.tysl_0[0].tysl_0_x_1.cellVal==''||dataarr.tysl_0[0].tysl_0_x_1.cellVal=='0'||dataarr.tysl_0[0].tysl_0_x_1.cellVal==null){
            // 		dataarr.tysl_0[0].tysl_0_x_1.cellVal = '30221'
            // 		dataarr.tysl_0[0].tysl_0_x_1a.cellVal = '水利建设专项收入'
            // 	}
            // 	dataarr.tysl_0.map((item,index)=>{
            // 		if(index!=dataarr.tysl_0.length-1){
            // 			this.selectchange(item,'tysl_')
            // 			this.selectchangetwo(item,'tysl_')
            // 			this.selectchangethree(item,'tysl_')
            // 		}
            //                     key.map(item1=>{
            //                         if(item[item1].cellVal==0){
            //                             item[item1]=''
            //                         }
            //                     })
            // 	})

            // 	this.tableDataI_III = dataarr.tysl_0
            // }
            // var newtableDataI = dataarr.sdsA_1.filter((item, index) => index < 2)
            // var realtableDataI = dataI.tableData
            // realtableDataI.forEach((item, index) => {
            // 	if (newtableDataI[index]) {
            // 		this.IHead.forEach(gtem => {
            // 			item[gtem] = newtableDataI[index][gtem]
            // 		})
            // 	}
            // })
            // this.tableDataI = realtableDataI

            // var newtableDatas = dataarr.sdsA_1.filter((item, index) =>index > 1&& index < 5)
            // var realtableDatas= dataI.tableDatas
            // realtableDatas.forEach((item, index) => {
            // 	if (newtableDatas[index]) {
            // 		this.IHead.forEach(gtem => {
            // 			item[gtem] = newtableDatas[index][gtem]
            // 		})
            // 	}
            // })
            // this.tableDatas = realtableDatas
        },
        selectchange(e, items) {
            this.option.map((item) => {
                if (item.value == e[`${items}0_x_1`].cellVal) {
                    e[`${items}0_x_1a`].cellVal = item.label;
                }
            });
            if (e[`${items}0_x_1`].cellVal == '30221') {
                e[`${items}0_x_2a`].option1 = [
                    {
                        value: '302210400',
                        label: '地方水利建设基金'
                    }
                ];
            } else if (e[`${items}0_x_1`].cellVal == '39900') {
                e[`${items}0_x_2a`].option1 = [
                    {
                        value: '399001010',
                        label: '工会筹备金'
                    }
                ];
            } else if (e[`${items}0_x_1`].cellVal == '30299') {
                e[`${items}0_x_2a`].option1 = [
                    {
                        value: '302990200',
                        label: '城镇垃圾处理费'
                    }
                ];
            }
        },
        selectchangetwo(e, items) {
            if (e[`${items}0_x_2a`].option1) {
                e[`${items}0_x_2a`].option1.map((item) => {
                    if (item.value == e[`${items}0_x_2`].cellVal) {
                        e[`${items}0_x_2a`].cellVal = item.label;
                    }
                });
                if (e[`${items}0_x_2`].cellVal == '302210400') {
                    e[`${items}0_x_3a`].option2 = [
                        {
                            value: '3022104002350001',
                            label: '企事业及个体（0.09%）'
                        },
                        {
                            value: '3022104002350002',
                            label: '银行保险企业'
                        },
                        {
                            value: '3022104002350003',
                            label: '非银行金融机构'
                        },
                        {
                            value: '3022104002350004',
                            label: '企事业及个体（0.07%）'
                        },
                        {
                            value: '3022104002350005',
                            label: '外商投资企业'
                        },
                        {
                            value: '3022104002350006',
                            label: '企事业及个体（0.1%）'
                        },
                        {
                            value: '3022104002350007',
                            label: '企事业及个体（0.05%）'
                        },
                        {
                            value: '3022104002350008',
                            label: '供水站'
                        },
                        {
                            value: '3022104002350009',
                            label: '外资银行、外资保险企业'
                        },
                        {
                            value: '3022104002610901',
                            label: '征占土地水利建设基金：水浇地'
                        },
                        {
                            value: '3022104002610902',
                            label: '征占土地水利建设基金：水田'
                        },
                        {
                            value: '3022104002610903',
                            label: '征占土地水利建设基金：旱地'
                        },
                        {
                            value: '3022104002610904',
                            label: '征占土地水利建设基金：其他土地'
                        },
                        {
                            value: '3022104002610001',
                            label: '企事业单位及个体经营者'
                        },
                        {
                            value: '3022104002610002',
                            label: '银行（含信用社）、保险业'
                        },
                        {
                            value: '3022104002610003',
                            label: '信托投资公司、财务公司等非银行金融机构'
                        },
                        {
                            value: '3022104002610004',
                            label: '阶段性降费'
                        },
                        {
                            value: '3022104002610005',
                            label: '中国（陕西）自贸区和西安自主创新区'
                        },
                        {
                            value: '3022104001610301',
                            label: '征占土地水利建设基金：水浇地'
                        },
                        {
                            value: '3022104001610302',
                            label: '征占土地水利建设基金：水田'
                        },
                        {
                            value: '3022104001610303',
                            label: '征占土地水利建设基金：旱地'
                        },
                        {
                            value: '3022104001610304',
                            label: '征占土地水利建设基金：其他土地'
                        }
                    ];
                    e[`${items}0_x_14`].option1 = [
                        {
                            value: '0099129901',
                            label: '月(季)销售额小于10 (30) 万元免征水本建设基金《财务部 国家务总局关于扩大有关政府性基金免征收的通知》 财税{2016} 12号第一条第 (一) 款 '
                        },
                        {
                            value: '0099129999',
                            label: '其他|其他|未备案'
                        },
                        {
                            value: '3499032401',
                            label: '中小微企业地方水利建设基金按现有费率90%征收|《安徽省财政厅 国家税务总局安徽省税务局关于我省中小微企业减征地方水利建设基金的通知》（皖财综 [2022] 299号)'
                        },
                        {
                            value: '3499042819',
                            label: '对月营业收入或销售收入额达不到流转税起征点的，不征收地方水利建设基金|《安做省财攻厅、安徽省地方稅务局关于调整地方水利建设基金征收管理有关政策的通知》 财综(200411102）（未备案)'
                        }
                    ];
                } else if (e[`${items}0_x_2`].cellVal == '399001010') {
                    e[`${items}0_x_3a`].option2 = [
                      {
                        value: '3990010102320001',
                        label: '工会筹备金（1%）'
                      },
                      {
                        value: '3990010102320002',
                        label: '工会筹备金（2%）'
                      },
                      {
                        value: '3990010102320003',
                        label: '工会筹备金（0.1%）'
                      },
                      {
                        value: '3990010102320004',
                        label: '工会筹备金（0.2%）'
                      },
                      {
                        value: '3990010102320005',
                        label: '工会筹备金（0.4%）'
                      },
                      {
                        value: '3990010102320006',
                        label: '工会筹备金（0.5%）'
                      },
                      {
                        value: '3990010102320007',
                        label: '工会筹备金（0.6%）'
                      },
                      {
                        value: '3990010102320008',
                        label: '工会筹备金（0.7%）'
                      },
                      {
                        value: '3990010102320009',
                        label: '工会筹备金（0.8%）'
                      },
                      {
                        value: '3990010102320010',
                        label: '工会筹备金（100%）'
                      }
                    ];
                    
                } else if (e[`${items}0_x_2`].cellVal == '302990200') {
                    e[`${items}0_x_3a`].option2 = [
                        {
                            value: '3043313001510002',
                            label: '城镇垃圾处理费[地市100%]'
                        }
                    ];
                }
            }
        },
        selectchangethree(e, items) {
            if (e[`${items}0_x_3a`].option2) {
                e[`${items}0_x_3a`].option2.map((item) => {
                    if (item.value == e[`${items}0_x_3`].cellVal) {
                        e[`${items}0_x_3a`].cellVal = item.label;
                    }
                });
            }
        },
        selectJm(e,items){
            console.log(e)
            if(e[`${items}0_x_2`].cellVal == "302210400"){
                e[`${items}0_x_14`].option1 = [
                    {
                        value: '0099129901',
                        label: '月(季)销售额小于10 (30) 万元免征水本建设基金《财务部 国家务总局关于扩大有关政府性基金免征收的通知》 财税{2016} 12号第一条第 (一) 款 '
                    },
                    {
                        value: '0099129999',
                        label: '其他|其他|未备案'
                    },
                    {
                        value: '3499032401',
                        label: '中小微企业地方水利建设基金按现有费率90%征收|《安徽省财政厅 国家税务总局安徽省税务局关于我省中小微企业减征地方水利建设基金的通知》（皖财综 [2022] 299号)'
                    },
                    {
                        value: '3499042819',
                        label: '对月营业收入或销售收入额达不到流转税起征点的，不征收地方水利建设基金|《安做省财攻厅、安徽省地方稅务局关于调整地方水利建设基金征收管理有关政策的通知》 财综(200411102）（未备案)'
                    }
                ];
            }
        },
        headchange(e) {
            this.headobj = e;
        },
        delCellsCode(e) {
            this.delCellsI = [...this.filternums(e, this.IHead)];
        },
        forsave() {
            const newarr = [...this.filternums(this.tableDataI_I, this.IHead)];
            let params = {
                cells: newarr,
                companyNo: this.params.companyNo,
                id: this.params.id,
                sbbm: this.params.sbbm,
                delCells: this.delCellsI,
                head: this.headobj,
                checkFlag: 'true'
            };
            writesave(params).then((res) => {
                if (res.data.code == 1) {
					this.Changed = 0
                    this.querycell();
                    this.$message.success(res.data.msg);
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        inputblur(e, codename, listname) {
            this.Changed++
            let cellval = e.cellVal == '' ? '0.00' : e.cellVal;
            if (
                parseFloat(e.cellVal).toFixed(2) !=
                    parseFloat(this[this.choosetable][this.chooseindex][this.choosecolum]['cellOldVal']).toFixed(2) &&
                this[this.choosetable][this.chooseindex][this.choosecolum]['cellCode'] == e.cellCode
            ) {
                this[this.choosetable][this.chooseindex][this.choosecolum]['cellType'] = '1';
            }
            let code =
                e.cellCode.substring(e.cellCode.length - 2, e.cellCode.length - 1) == '_'
                    ? e.cellCode.substring(e.cellCode.length - 1, e.cellCode.length)
                    : e.cellCode.substring(e.cellCode.length - 2, e.cellCode.length);
            let num =
                e.cellCode.substring(e.cellCode.length - code.length - 3, e.cellCode.length - code.length - 2) == '_'
                    ? e.cellCode.substring(e.cellCode.length - code.length - 2, e.cellCode.length - code.length - 1)
                    : e.cellCode.substring(e.cellCode.length - code.length - 3, e.cellCode.length - code.length - 2);
					console.log(code)
					console.log(num)
            if (code == '3a') {
                this.tableDataI_I.map((item, index) => {
                    if (index + 1 == num) {
                        if (item.ty_0_x_1.cellVal == '39900') {
                            if (e.cellVal.substring(e.cellVal.length - 1, e.cellVal.length) == '1') {
                                // item.ty_0_x_8.cellVal = ${e.cellVal.substring(e.cellVal.length-1,e.cellVal.length)}
                                this.changetableval(
                                    `ty_0_${num}_8`,
                                    `tableDataI_I`,
                                    e.cellVal.substring(e.cellVal.length - 1, e.cellVal.length),
                                    null,
                                    4
                                );
                            } else if (e.cellVal.substring(e.cellVal.length - 1, e.cellVal.length) == '5') {
                                this.changetableval(
                                    `ty_0_${num}_8`,
                                    `tableDataI_I`,
                                    e.cellVal.substring(e.cellVal.length - 2, e.cellVal.length),
                                    null,
                                    4
                                );
                                // item.ty_0_x_8.cellVal = `${e.cellVal.substring(e.cellVal.length-2,e.cellVal.length)}`
                            } else {
                                this.changetableval(
                                    `ty_0_${num}_8`,
                                    `tableDataI_I`,
                                    e.cellVal.substring(4, e.cellVal.length - 1) / 100,
                                    null,
                                    4
                                );
                                // item.ty_0_x_8.cellVal = `${e.cellVal.substring(4,e.cellVal.length-1)/100}`
                            }
                            // this.changetableval( `ty_0_${num}_9`, `tableDataI_I`, this.gettableval(`ty_0_${num}_6`, `tableDataI_I`) -
                            // 	this.gettableval(`ty_0_${num}_7`, `tableDataI_I`)*this.gettableval(`ty_0_${num}_8`, `tableDataI_I`))
                        }
                    }
                });
            }
            if (code == 6) {
                this.changetableval(
                    `ty_0_${num}_9`,
                    `tableDataI_I`,
                    this.gettableval(`ty_0_${num}_6`, `tableDataI_I`) -
                        this.gettableval(`ty_0_${num}_7`, `tableDataI_I`) * this.gettableval(`ty_0_${num}_8`, `tableDataI_I`)
                );
            }
            if (code == 7) {
                this.changetableval(
                    `ty_0_${num}_9`,
                    `tableDataI_I`,
                    this.gettableval(`ty_0_${num}_6`, `tableDataI_I`) - this.gettableval(`ty_0_${num}_7`, `tableDataI_I`)
                );
            }
            if (code == 8) {
                this.changetableval(
                    `ty_0_${num}_13`,
                    `tableDataI_I`,
                    (this.gettableval(`ty_0_${num}_9`, `tableDataI_I`) * this.gettableval(`ty_0_${num}_10`, `tableDataI_I`) -
                        this.gettableval(`ty_0_${num}_12`, `tableDataI_I`)) *
                        this.gettableval(`ty_0_${num}_8`, `tableDataI_I`)
                );
            }
            if (code == 9) {
                this.changetableval(
                    `ty_0_${num}_13`,
                    `tableDataI_I`,
                    (this.gettableval(`ty_0_${num}_9`, `tableDataI_I`) * this.gettableval(`ty_0_${num}_10`, `tableDataI_I`) -
                        this.gettableval(`ty_0_${num}_12`, `tableDataI_I`)) *
                        this.gettableval(`ty_0_${num}_8`, `tableDataI_I`)
                );
            }
            if (code == 10) {
                this.changetableval(
                    `ty_0_${num}_13`,
                    `tableDataI_I`,
                    (this.gettableval(`ty_0_${num}_9`, `tableDataI_I`) * this.gettableval(`ty_0_${num}_10`, `tableDataI_I`) -
                        this.gettableval(`ty_0_${num}_12`, `tableDataI_I`)) *
                        this.gettableval(`ty_0_${num}_8`, `tableDataI_I`)
                );
            }
            if (code == 12) {
                this.changetableval(
                    `ty_0_${num}_13`,
                    `tableDataI_I`,
                    (this.gettableval(`ty_0_${num}_9`, `tableDataI_I`) * this.gettableval(`ty_0_${num}_10`, `tableDataI_I`) -
                        this.gettableval(`ty_0_${num}_12`, `tableDataI_I`)) *
                        this.gettableval(`ty_0_${num}_8`, `tableDataI_I`)
                );
            }
            if (code == 13) {
                this.changetableval(
                    `ty_0_${num}_17`,
                    `tableDataI_I`,
                    this.gettableval(`ty_0_${num}_13`, `tableDataI_I`) -
                        this.gettableval(`ty_0_${num}_15`, `tableDataI_I`) -
                        this.gettableval(`ty_0_${num}_16`, `tableDataI_I`)
                );
                this.tylj_0_1000_13('ty', 'tableDataI_I');
            }
			if(code==14){
				if(e.cellVal=="0099129901"){
			if(this.params.jid=='1'){
				if(parseFloat(this.gettableval(`ty_0_${num}_6`, `tableDataI_I`))>=100000){
					this.changetableval(
					    `ty_0_${num}_15`,
					    `tableDataI_I`,
					    0);
				}else{
					this.changetableval(
					    `ty_0_${num}_15`,
					    `tableDataI_I`,
					    this.gettableval(`ty_0_${num}_13`, `tableDataI_I`));
				}
			}else if(this.params.jid=='2'){
				if(parseFloat(this.gettableval(`ty_0_${num}_6`, `tableDataI_I`))>=300000){
					this.changetableval(
					    `ty_0_${num}_15`,
					    `tableDataI_I`,
					    0);
				}else{
					this.changetableval(
					    `ty_0_${num}_15`,
					    `tableDataI_I`,
					    this.gettableval(`ty_0_${num}_13`, `tableDataI_I`));
				}
			}
					}
			}
            if (code == 15) {
                this.changetableval(
                    `ty_0_${num}_17`,
                    `tableDataI_I`,
                    this.gettableval(`ty_0_${num}_13`, `tableDataI_I`) -
                        this.gettableval(`ty_0_${num}_15`, `tableDataI_I`) -
                        this.gettableval(`ty_0_${num}_16`, `tableDataI_I`)
                );
                this.tylj_0_1000_15('ty', 'tableDataI_I');
            }
            if (code == 16) {
                this.changetableval(
                    `ty_0_${num}_17`,
                    `tableDataI_I`,
                    this.gettableval(`ty_0_${num}_13`, `tableDataI_I`) -
                        this.gettableval(`ty_0_${num}_15`, `tableDataI_I`) -
                        this.gettableval(`ty_0_${num}_16`, `tableDataI_I`)
                );
                this.tylj_0_1000_16('ty', 'tableDataI_I');
            }
            if (code == 17) {
                this.tylj_0_1000_17('ty', 'tableDataI_I');
            }
        },

        tylj_0_1000_13() {
            let total = 0;
            this.tableDataI_I.map((item) => {
                Object.keys(item).map((key) => {
                    let Code = key.substring(key.length - 2, key.length);
                    if (Code == 13 && item[key].cellCode != `ty_0_1000_13`) {
                        total += Number(item[key].cellVal);
                    }
                });
            });
            this.changetableval(`ty_0_1000_13`, `tableDataI_I`, total);
        },
        tylj_0_1000_15(codename, listname) {
            let total = 0;
            this.tableDataI_I.map((item) => {
                Object.keys(item).map((key) => {
                    let Code = key.substring(key.length - 2, key.length);
                    if (Code == 15 && item[key].cellCode != `ty_0_1000_15`) {
                        total += Number(item[key].cellVal);
                    }
                });
            });
            this.changetableval(`ty_0_1000_15`, `tableDataI_I`, total);
        },
        tylj_0_1000_16(codename, listname) {
            let total = 0;
            this.tableDataI_I.map((item) => {
                Object.keys(item).map((key) => {
                    let Code = key.substring(key.length - 2, key.length);
                    if (Code == 16 && item[key].cellCode != `ty_0_1000_16`) {
                        total += Number(item[key].cellVal);
                    }
                });
            });
            this.changetableval(`ty_0_1000_16`, `tableDataI_I`, total);
        },
        tylj_0_1000_17(codename, listname) {
            let total = 0;
            this.tableDataI_I.map((item) => {
                Object.keys(item).map((key) => {
                    let Code = key.substring(key.length - 2, key.length);
                    if (Code == 17 && item[key].cellCode != `ty_0_1000_17`) {
                        total += Number(item[key].cellVal);
                    }
                });
            });
            this.changetableval(`ty_0_1000_17`, `tableDataI_I`, total);
        },
        gettableval(changecode, table, old) {
            var head = '';
            if (table == `tableDataI_I`) {
                head = 'IHead';
            }
            if (table == `tableDataI_II`) {
                head = 'IIHead';
            }
            if (table == `tableDataI_III`) {
                head = 'IIIHead';
            }
            var a;
            if (this[table] && this[head]) {
                for (let i = 0; i < this[table].length; i++) {
                    for (let j = 0; j < this[head].length; j++) {
                        if (
                            this[table][i][this[head][j]] &&
                            this[table][i][this[head][j]].cellCode &&
                            this[table][i][this[head][j]].cellVal &&
                            this[table][i][this[head][j]].cellCode == changecode
                        ) {
                            if (old) {
                                if (this.$emptyandnull(this[table][i][this[head][j]].goujgxValue)) {
                                    a = 0;
                                } else {
                                    a = parseFloat(this[table][i][this[head][j]].goujgxValue);
                                }
                            } else {
                                if (this[table][i][this[head][j]].cellVal == '-') {
                                    a = 0;
                                } else {
                                    a = parseFloat(this[table][i][this[head][j]].cellVal || 0);
                                }
                            }
                            break;
                        }
                    }
                }
            }
            a = a || 0;
            if (
                changecode == 'sdsA_1_18_1' ||
                changecode == 'sdsA_1_19_1' ||
                changecode == 'sdsA_1_20_1' ||
                changecode == 'sdsA_1_20_2' ||
                changecode == 'sdsA_1_23.2_2'
            ) {
                if (!a < 1) {
                    a = a * 0.01;
                }
            }
            return a;
        },
        changetableval(changecode, table, newval, checkq, digit) {
            var newval = newval || 0;
            if (digit) {
                newval = this.toFixed(newval, digit);
            } else {
                newval = this.toFixed(newval, 2);
            }
            var head = '';
            if (table == `tableDataI_I`) {
                head = 'IHead';
            }
            if (table == `tableDataI_II`) {
                head = 'IIHead';
            }
            if (table == `tableDataI_III`) {
                head = 'IIIHead';
            }
            for (let i = 0; i < this[table].length; i++) {
                for (let j = 0; j < this[head].length; j++) {
                    if (
                        this[table][i][this[head][j]] &&
                        this[table][i][this[head][j]].cellCode &&
                        typeof this[table][i][this[head][j]].cellVal != 'undefined' &&
                        typeof this[table][i][this[head][j]].cellVal != undefined &&
                        this[table][i][this[head][j]].cellCode == changecode
                    ) {
                        if (this[table][i][this[head][j]].cellVal != newval) {
                            if (this.suosq.substring(4, 6) < 5 && checkq) {
                                this[table][i][this[head][j]].cellVal = '';
                            } else {
                                this[table][i][this[head][j]].cellVal = newval + '';
                            }
                            this.inputblur({
                                cellCode: changecode,
                                cellVal: newval
                            });
                            break;
                        }
                    }
                }
            }
        }
    }
};
</script>


<style scoped lang="less">
@import url('./index.less');
</style>
